import React, { useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { Plus, Trash2, BookMarked } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const SubjectsManager = ({ subjects, reload }) => {
    const [en, setEn] = useState('');
    const [ar, setAr] = useState('');
    const add = async () => {
        if (!en.trim() && !ar.trim()) { toast.error('Enter the subject name'); return; }
        try { await axios.post(`${API_URL}/api/subjects`, { name_en: en, name_ar: ar }, { withCredentials: true }); toast.success('Subject added'); setEn(''); setAr(''); reload(); }
        catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
    };
    const del = async (s) => {
        if (!window.confirm(`Delete subject "${s.name_en}"?`)) return;
        try { await axios.delete(`${API_URL}/api/subjects/${s.id}`, { withCredentials: true }); toast.success('Subject deleted'); reload(); }
        catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
    };
    return (
        <Card className="card-surface" data-testid="subjects-manager">
            <CardHeader className="pb-2"><CardTitle className="text-base font-['Outfit'] flex items-center gap-2"><BookMarked className="h-5 w-5 text-[#064E3B]" />Subjects list <span className="text-xs font-normal text-[#6B7280]">— used by classes, teachers and books</span></CardTitle></CardHeader>
            <CardContent className="space-y-3">
                <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-2 items-end">
                    <div className="space-y-1"><Label>English name</Label><Input value={en} onChange={e => setEn(e.target.value)} placeholder="Tajweed" data-testid="subject-new-en" /></div>
                    <div className="space-y-1"><Label>Arabic name</Label><Input value={ar} onChange={e => setAr(e.target.value)} placeholder="تجويد" dir="rtl" data-testid="subject-new-ar" /></div>
                    <Button className="bg-[#064E3B] hover:bg-[#047857]" onClick={add} data-testid="subject-add-btn"><Plus className="h-4 w-4 mr-1" />Add subject</Button>
                </div>
                <div className="divide-y border rounded-md">
                    {subjects.length === 0 && <p className="p-4 text-sm text-[#6B7280] text-center">No subjects yet.</p>}
                    {subjects.map(s => (
                        <div key={s.id} className="p-2.5 flex items-center gap-3" data-testid={`subject-item-${s.id}`}>
                            <p className="font-medium flex-1">{s.name_en}</p><p className="text-sm text-[#6B7280] flex-1" dir="rtl">{s.name_ar}</p>
                            <Button size="sm" variant="ghost" className="text-[#DC2626]" onClick={() => del(s)} data-testid={`subject-delete-${s.id}`}><Trash2 className="h-4 w-4" /></Button>
                        </div>))}
                </div>
                <p className="text-xs text-[#6B7280]">A subject that is still used by a class cannot be deleted.</p>
            </CardContent>
        </Card>
    );
};
